import { W as WuiCheckInputGroup$1, d as defineCustomElement$1 } from './check-input-group.js';

const WuiCheckInputGroup = WuiCheckInputGroup$1;
const defineCustomElement = defineCustomElement$1;

export { WuiCheckInputGroup, defineCustomElement };

//# sourceMappingURL=wui-check-input-group.js.map